import React, { useState } from 'react';
import { reviewService } from '../services/reviewService';

function StarSelector({ value, onChange }) {
  return (
    <span className="stars" style={{ cursor: 'pointer', fontSize: '1.5rem' }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span
          key={n}
          className={n <= value ? 'star-filled' : 'star-empty'}
          onClick={() => onChange(n)}
        >★</span>
      ))}
    </span>
  );
}

function ReviewForm({ productId, reviewedUsername, onComplete, onCancel }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rating) return;
    setSending(true);
    setError('');
    try {
      await reviewService.create({
        reviewedUsername,
        productId,
        rating,
        comment: comment.trim() || null,
      });
      if (onComplete) onComplete();
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data || 'Error al enviar calificación');
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card" style={{ marginTop: '1rem' }}>
      <div style={{ marginBottom: '0.75rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', color: 'var(--text-muted)', fontSize: '0.82rem', fontWeight: 600, textTransform: 'uppercase' }}>
          Calificar a {reviewedUsername}
        </label>
        <StarSelector value={rating} onChange={setRating} />
      </div>
      <div className="form-group">
        <label>Comentario (opcional)</label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Contá tu experiencia..."
          style={{ resize: 'vertical' }}
        />
      </div>
      {error && <div className="error-message">{error}</div>}
      <div style={{ display: 'flex', gap: '0.65rem' }}>
        <button type="submit" className="btn btn-primary btn-sm" disabled={sending || !rating}>
          {sending ? <><span className="spinner" /> Enviando...</> : 'Enviar calificación'}
        </button>
        {onCancel && (
          <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>
            Cancelar
          </button>
        )}
      </div>
    </form>
  );
}

export default ReviewForm;
